import React from 'react'

const EraserIcon = ({color = 'currentColor', bgColor = 'white', borderColor = '#D8DBDE', width = 32, height = 32, ...rest}) => (
    <svg width={width} height={height} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
        <circle cx="16" cy="16" r="15.5" fill={bgColor} stroke={borderColor} />
        <path d="M21.25 16.75H10.75V15.25H21.25V16.75Z" fill={color} />
    </svg>
)

export default EraserIcon
